<template>
  <div class="contact">

    <contact-form> </contact-form>
    <location />    
    
    <!-- <div class="page light">
      Alternitively feel free to get in touch with us through our <a href="http://www.facebook.com/copsecornermusic">Facebook page</a> or
      give us a ring on O7595 33787O.

      <p>
      Copse Corner Music <br />
      Knowstone Court, <br />
      Knowstone, <br />
      South Molton, <br />
      Devon <br />
      EX36 4RW </p>
      <p><em>
        Please note that visits to the studio are by appointment only.
      </em></p>
    </div> -->
<div class="faq page light">
  <div class="inner">
    <h1>FAQ's</h1>
      <p><strong>Do you offer work experience places or internships?</strong><br />
      Unfortunately we do not currently offer work experience places or internships. Please do not send CVs or emails requesting work experience or internships.</p>

      <p><strong>Can I bring my project stems to the studio for them to be mixed and mastered?</strong> <br />
      Yes, absolutely, we are asked to do this all the time. Just make sure your stems all start at the same point, are .wav format at either 44.1 kHz 16 bit or 48 kHz 24 bit, and contained on a DVD. If you are bringing stems for several songs, please make seperate folders for each song, or if each song contains many stems, put each song on a seperate DVD.</p>

      <!-- <p>Why do you use Cubase instead of Pro Tools?</p>

      <p>The simple answer is, one; to keep your costs down, and two; in many ways Cubase is just as good if not better. Yes, Pro Tools has become the 'industry standard' DAW but, the way it has been designed means that it is very expensive to run. Where other DAWs will work with many and varied third party PlugIns and hardware, Pro Tools is much less compatible, and the hardware required to run Pro Tools at its optimum is very expensive. Cubase, although more expensive to purchase initially than Pro Tools, has a much wider compatibility platform. In many people's opinion Cubase 6.5 that we use here, can outperform the equivalent version of Pro Tools in many areas. We would not be able to offer such competitive prices here at Copse Corner while running a Pro Tools set-up, without compromising quality elsewhere. Please rest assured that we strive to set a very high standard of recording and production in every project we take on.</p> -->

      <p><strong>Why are visits to the studio by appointment only?</strong><br />

      This is to ensure that you are not kept waiting after driving all the way to the studio. When recording is in progress, no one is admitted to the studio and a recording is never interrupted under any circumstance. Therefore if you turn up without notice you may end up waiting quite some time before someone is available to see you.</p>
  </div>
  </div>
<cc-map></cc-map>
  </div>
</template>

<script>
import ContactForm from '@/components/ContactForm2.vue'
import CcMap from '@/components/CcMap.vue'
import Location from '@/components/Location.vue'
export default {
  name: 'contact', 
  components: {
    ContactForm,
    CcMap,
    Location
  }
}
</script>

<style>
  .faq{
    min-height: 0;
  }
  .inner{
    max-width:1200px;
    margin: 0 auto;
  }
</style>